import { Pipe, PipeTransform } from '@angular/core';
import { filterOperatorsLabelDictionary } from '../constants/filter-operators.constant';

@Pipe({
  name: 'filterOperator',
})
export class FilterOperatorPipe implements PipeTransform {
  transform(value: any, ...args: any[]) {
    return filterOperatorsLabelDictionary.get(value);
  }
}
